<template>
  <div id="app" :class="classes">
    <template v-if="isIE">
      <error-page code="not_compatible" />
    </template>
    <template v-else>
      <service-worker-notification v-if="false" is-absolute />
      <custom-notification :duration="3000" />
      <main>
        <loader-text
          v-if="_.isNull($route.name)"
          title="dashboard.loading"
        />
        <template v-else>
          <main-menu />
          <router-view :key="$route.fullPath" />
          <main-footer v-if="user()" />
        </template>
      </main>
    </template>
  </div>
</template>

<script>
  import ServiceWorkerNotification from '@triotech/vue-core/src/components/ServiceWorkerNotification';
  import CustomNotification from '@triotech/vue-core/src/components/CustomNotification';
  import ErrorPage from '@/components/error';
  import LoaderText from '@/components/loader-text';
  import MainMenu from '@/components/main-menu';
  import MainFooter from '@/components/footer';

  export default {
    name: 'App',
    components: {
      ServiceWorkerNotification,
      CustomNotification,
      ErrorPage,
      LoaderText,
      MainMenu,
      MainFooter,
    },
    computed: {
      classes() {
        let classes = '';

        if (this.user()) {
          classes = 'connected';
          if (this.$helper.isLegacy) {
            classes += ' legacy-platform';
          }
        } else {
          classes = 'disconnected';
        }

        return classes;
      },
      isIE() {
        return navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/));
      },
    },
    created() {
      this.$i18n.fallbackLocale = 'fr';
      this.$helper.setLocale(this.user() ? this.user().preferred_locale : window.navigator.language);
    },
  };
</script>

<style lang="scss">
  @import '~@/scss/frontend';
</style>
